module.exports = [{
      plugin: require('/Users/gerverdugo/dev/js/stin-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
